(ns manage.ad-variant-insights.tables.decision-paths
  (:require ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [manage.ad-variant-insights.tables.common :as table.common]
            [uix.core :as uix :refer [$ defui]]))

(def decision-path-columns
  #js [#js {:field "decision-path"
            :headerName "Decision Path"
            :flex 6
            :minWidth 250
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:decision_path row))}
       #js {:field "impressions"
            :headerName "Impressions"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:impressions row))
            :valueFormatter table.common/format-number}
       #js {:field "clicks"
            :headerName "Clicks"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:clicks row))
            :valueFormatter table.common/format-number}
       #js {:field "ctr"
            :headerName "CTR"
            :flex 1
            :align "right"
            :headerAlign "right"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:ctr row))
            :valueFormatter table.common/format-ctr}])

(defn get-decision-path-row-id [row]
  (:decision_tree_path row))

(defui decision-path-rankings-table [{:keys [paths]}]
  ($ DataGridPremium
     {:rows (to-array paths)
      :slots #js {:noRowsOverlay (uix/as-react table.common/NoRowsOverlay)}
      :initialState #js {:sorting #js {:sortModel #js [#js {:field "ctr"
                                                            :sort "desc"}]}}

      :columns decision-path-columns
      :getRowId get-decision-path-row-id}))

